import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';

interface DialogContentSuccessProps {
  waitBlock: boolean;
}

const DialogContentSuccess: React.FC<DialogContentSuccessProps> = ({ waitBlock }) => {
  return (
    <>
      <CheckCircleIcon sx={{ fontSize: 50, color: green[500], marginTop: 1 }} />
      {waitBlock ? (
        <Stack>
          <Typography variant="body1">
            Your action was successful! Execution on the network side will finish
          </Typography>
          <Typography variant="body1">
            <Box component="span" fontWeight="bold">
              in a minute or two.
            </Box>
          </Typography>
        </Stack>
      ) : (
        <Stack>
          <Typography variant="body1">Your action was successful!</Typography>
        </Stack>
      )}
    </>
  );
};

export default DialogContentSuccess;
